import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IEntityValueDeviceModel, IEntityValueTankModel, IEntityValueWellModel } from "../../common/models/IEntityValueModels";
import { ITankBattery } from "../../common/models/ITankBattery";
import { RestError } from "../../services/rest-service/RestService";
import TagValueDataService from "../../services/tag-value-data-service/TagValueDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";


export type UseTagValuesQueryParams = {
    customerID: number;
    groupID: number;
    objectID: number;
    objectType: eLynxObjectTypeEnum;
    date: Date | undefined;
    offline: boolean;
    useLKVOffline: boolean;
    configurationID?: number;
    manualEntry?: boolean;
} & BaseUseQueryParameters<IEntityValueDeviceModel | IEntityValueWellModel | IEntityValueTankModel | ITankBattery | undefined>;


export function useTagValues(params: UseTagValuesQueryParams) {

    const entity = {
        id: params.objectID,
        objectType: params.objectType
    } as IeLynxObject;

    return useQuery<IEntityValueDeviceModel | IEntityValueWellModel | IEntityValueTankModel | ITankBattery | undefined, RestError>(
        keys.data(params.customerID,
            params.groupID,
            entity,
            params.date,
            params.offline,
            params.useLKVOffline,
            params.configurationID
        ),
        ({ signal }) => {
            return TagValueDataService.getTagValueData(
                params.customerID, 
                params.groupID, 
                entity, 
                params.date, 
                params.offline, 
                params.useLKVOffline,
                params.configurationID,
                signal);
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.manualEntry ? false : params.refreshSeconds ? params.refreshSeconds  * 1000 : false,
            //staleTime: params.manualEntry ? Infinity : undefined
            //staleTime: 0
            //staleTime: params.manualEntry ? Infinity : undefined,
            //refetchOnMount: params.manualEntry ? 'always' : undefined
            // staleTime: params.manualEntry ? 0 : undefined,
            // SPR 04-11-2025 - This is necessary to ensure that object details grids are auto-sized each time we
            // navigate to them.
            cacheTime: 0,
            //staleTime: 0,
            staleTime: params.staleTime ?? 0,
            refetchOnWindowFocus: false,
            refetchOnMount: params.manualEntry ? 'always' : undefined


        }
    );
}

